import { render, staticRenderFns } from "./AttributeFormRow.vue?vue&type=template&id=c65e6fb4&"
import script from "./AttributeFormRow.vue?vue&type=script&lang=js&"
export * from "./AttributeFormRow.vue?vue&type=script&lang=js&"
import style0 from "./AttributeFormRow.vue?vue&type=style&index=0&id=c65e6fb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports